import * as loadQueueHelper from '../../../js/document/load-queue'
import SkiPrices from './main'

loadQueueHelper.add(function () {
  SkiPrices.createInstancesOnDocument()
})
